import { EmailVerification } from "@shared/src/components/modules/auth/EmailVerification";
import { AccountLinkingView } from "@shared/src/components/modules/auth/AccountLinkingView";
import { SocialLoginView } from "@shared/src/components/modules/auth/SocialLoginView";
import { WalletConnection } from "@shared/src/components/modules/auth/WalletConnection";
import { WhitelistCheckView } from "@shared/src/components/modules/auth/WhitelistCheckView";

export function ViewContent({
  selectedView,
  isVerifying,
  walletName,
  walletIcon,
}: {
  selectedView: string;
  isVerifying: boolean;
  walletName: string;
  walletIcon: string;
}) {
  if (isVerifying) {
    return <EmailVerification />;
  }

  if (selectedView === "all") {
    return (
      <div className="w-full flex items-center justify-center py-8">
        <p className="text-text-secondary text-center">Loading wallet options...</p>
      </div>
    );
  }

  if (selectedView === "social") {
    return <SocialLoginView />;
  }

  if (selectedView === "account_linking") {
    return <AccountLinkingView />;
  }

  if (selectedView === "whitelist_check") {
    return <WhitelistCheckView />;
  }

  return <WalletConnection walletName={walletName} walletIcon={walletIcon as string} type="wallet" />;
}
